
export type QueryMetrics200ItemTags = {[key: string]: string};
